//@ts-nocheck

import Swiper from "swiper";
import { Scrollbar } from "swiper/modules";

const dropSlider = () => {
  const sliders = document.querySelectorAll(".js-drop-slider");
  if (sliders.length == 0) {
    return;
  }
  const bars = document.querySelectorAll(".swiper-scrollbar");

  bars.forEach((bar, index) => {
    let classname = "scrollbar-" + index;
    bar.classList.add(classname);
  });

  sliders.forEach((slider, index) => {
    let classname = document.querySelector(".scrollbar-" + index);
    let dropSlide = new Swiper(slider, {
      slidesPerView: "auto",
      spaceBetween: 16,
      modules: [Scrollbar],
      scrollbar: {
        el: classname,
        draggable: true,
        dragSize: 320,
      },
    });
  });
};

export default dropSlider;
